import canUser from '@pkg/entities/users/access/can';

/**
 * @param {Object} me
 * @param {Object} permissions
 * @param {Boolean} isScenario
 * @returns {Boolean}
 */
export default function publish(me, permissions, isScenario) {
  return (
    isScenario &&
    canUser(me, permissions.design.write) &&
    canUser(me, permissions.organisation.manage)
  );
}
